import useStyles from './DocumentToDeleteOverlay.styles';
import {CloseFilled} from 'components/icons';

const SelectedDocumentPure = (): JSX.Element => {
  const classes = useStyles();
  return <CloseFilled className={classes.image} fontSize='xlarge' />;
};

type SelectedDocumentProps = {
  selected: boolean;
};

const DocumentToDeleteOverlay = ({
  selected,
}: SelectedDocumentProps): JSX.Element | null => {
  if (!selected) {
    return null;
  }

  return <SelectedDocumentPure />;
};

export default DocumentToDeleteOverlay;
